import { render, staticRenderFns } from "./dossier-detail-component-actions.vue?vue&type=template&id=0c8035a7&scoped=true"
import script from "./dossier-detail-component-actions.vue?vue&type=script&lang=ts"
export * from "./dossier-detail-component-actions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8035a7",
  null
  
)

export default component.exports